import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import CustomFieldService from '../../services/CustomFieldService';


const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'
    
};



export const fetchCustomFIelds = createAsyncThunk('customField', async () => {
    const response = await CustomFieldService.getPayrollByPage();
    return response;
});


export const CustomFieldSlice = createSlice({
    name: 'customField',
    initialState,
    reducers: {
        addPayrollColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToPayrollColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomFIelds.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCustomFIelds.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
            
    }
});


export const selectCustomField = (state) => state.customField.data;
